core.directive('esfNipValidator', [
        function() {
            var definition = {
                restrict: "A",
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    ctrl.$validators.nipValidator = function(modelValue, viewValue) {

                        if(scope.identifierType == Enum.IDENTIFIER_TYPE.OTHER || (scope.identifierType == Enum.IDENTIFIER_TYPE.OTHER && modelValue.length < 11)) {
                            return true;
                        }
                        if(!modelValue) {
                            return false;
                        }
                        var NIP = modelValue;
                        if (!(NIP == null || NIP == ""))  {
                            NIP = NIP.replace(/[\s-]/g, "");
                            var controlValue = parseInt(NIP.charAt(9));
                            var weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
                            if (NIP.length == 10 && parseInt(NIP, 10) > 0) {
                                var controlSum = 0;
                                for(var i = 0; i<9; i++) {
                                    controlSum += parseInt(NIP.charAt(i)) * weights[i];
                                }
                                var controlResult = controlSum % 11;
                                var controlRest = (controlResult == 10)?0:controlResult;
                                return controlRest == controlValue;
                            }
                        };
                        return false;
                    }
                }
            };

            return definition;
        }]
);